import { render, staticRenderFns } from "./ReportCompetition.vue?vue&type=template&id=7ba2f230&"
import script from "./ReportCompetition.vue?vue&type=script&lang=js&"
export * from "./ReportCompetition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/blocks/ReportCompetition.vue
// module id = null
// module chunks = 